import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiX } from "react-icons/hi";

const PROMO_IMAGE = "/assets/nepali-thali-promo.png";

export default function PromoModal() {
  // Shows every time the site is opened.
  const [open, setOpen] = useState(true);

  const close = () => {
    setOpen(false);
    document.body.style.overflow = "";
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-[200] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
          onClick={close}
          role="dialog"
          aria-modal="true"
          aria-label="Nepali Dal Bhaat promotion"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="relative max-w-lg w-full max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={close}
              className="absolute -top-3 -right-3 z-10 w-10 h-10 rounded-full bg-white text-charcoal shadow-lg flex items-center justify-center hover:bg-gray-100 hover:scale-105 transition-all"
              aria-label="Close promotion"
            >
              <HiX className="w-6 h-6" />
            </button>
            <img
              src={PROMO_IMAGE}
              alt="Have you tried our Nepali Dal Bhaat yet? Veg, Chicken and Mutton Thali specials."
              className="w-full max-h-[90vh] rounded-xl object-contain shadow-2xl"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
